import { render, staticRenderFns } from "./HomeStats.vue?vue&type=template&id=18e5f7ce"
import script from "./HomeStats.vue?vue&type=script&lang=js"
export * from "./HomeStats.vue?vue&type=script&lang=js"
import style0 from "./HomeStats.vue?vue&type=style&index=0&id=18e5f7ce&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports